import { useFirebaseLogin } from "@/app/hooks/api_hooks/auth/useFirebaseLogin";
import { useRouter } from "@/app/hooks/useRouter";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const LogoutPage = () => {
  const { getRouteKey } = useRouter();
  const { clientSignOut } = useFirebaseLogin();
  const navigate = useNavigate();
  useEffect(() => {
    clientSignOut();
    navigate(getRouteKey("LOGIN_PAGE", "url"));
  }, []);
  return null;
};

export default LogoutPage;
